import type { StateCreator } from 'zustand';

import { ESR_BADGE } from '../../utils/constants/localStorage';
import { getLocalStorageObject, setLocalStorageObject } from '../../utils/functions/localStorage';
import type { GlobalStore, ProjectSlice } from '../schema';

function loadEsrBadgeFromStorage(): Map<string, boolean> {
  const stored = getLocalStorageObject(ESR_BADGE);
  if (stored == null) return new Map<string, boolean>();
  if (stored instanceof Map) return stored as Map<string, boolean>;
  if (Array.isArray(stored)) {
    try {
      return new Map<string, boolean>(stored as [string, boolean][]);
    } catch {
      return new Map<string, boolean>();
    }
  }
  if (typeof stored === 'object') {
    return new Map<string, boolean>(Object.entries(stored as Record<string, boolean>));
  }
  return new Map<string, boolean>();
}

const defaultProjectSlice = {
  projectData: null,
  essRatingData: null,
  isLoading: true,
  relatedContentArticles: [] as Array<any>,
  esrBadge: loadEsrBadgeFromStorage(),
  sellerOffersStats: null,
  sellerOffers: [] as any[],
  isSellerOfferDataLoading: true,
};

export const createProjectSlice: StateCreator<
  GlobalStore,
  [['zustand/devtools', never]],
  [],
  ProjectSlice
> = (set, get) => ({
  ...defaultProjectSlice,
  setProjectState: (updates) => {
    const next = { ...updates };
    if (updates.esrBadge !== undefined) {
      setLocalStorageObject(ESR_BADGE, updates.esrBadge);
    }
    set(next as Partial<GlobalStore>, false, 'project/set');
  },
  resetProjectState: () => {
    const currentBadge = get().esrBadge;
    set({ ...defaultProjectSlice, esrBadge: currentBadge }, false, 'project/reset');
  },
  markEsrBadge: (projectId, value) => {
    const current = get().esrBadge;
    const next = new Map(current);
    next.set(projectId, value);
    setLocalStorageObject(ESR_BADGE, Array.from(next.entries()));
    set({ esrBadge: next }, false, 'project/markEsrBadge');
  },
});
